import { render, staticRenderFns } from "./auth-reset-password.vue?vue&type=template&id=1ef695b1&"
import script from "./auth-reset-password.vue?vue&type=script&lang=js&"
export * from "./auth-reset-password.vue?vue&type=script&lang=js&"
import style0 from "./auth-reset-password.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports